/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/429-steam': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M11 4.5a1.5 1.5 0 113.001.001A1.5 1.5 0 0111 4.5zm3.975-2.475A3.5 3.5 0 009.036 4L5.838 8.847c-.43.022-.856.132-1.249.328L2.122 7.247A1.313 1.313 0 00.506 9.315l2.436 1.905a3.157 3.157 0 106.168.228l3.891-3.484a3.5 3.5 0 001.975-5.939zM6 14.105A2.105 2.105 0 013.895 12l.001-.033 1.046.817a1.31 1.31 0 101.616-2.068l-.992-.776A2.105 2.105 0 116 14.105zM12.5 7a2.5 2.5 0 110-5 2.5 2.5 0 010 5z"/>'
  }
})
